export default "__VITE_ASSET__ce476c96__"